import React from 'react';

export const MobileIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="210" height="200" viewBox="0 0 210 200" fill="#A1ACB3" {...props}>
    <path
      d="M84 51C80.1281 51 77 54.1281 77 58V142C77 145.872 80.1281 149 84 149H126C129.872 149 133 145.872 133 142V58C133 54.1281 129.872 51 126 51H84ZM70 58C70 50.2781 76.2781 44 84 44H126C133.722 44 140 50.2781 140 58V142C140 149.722 133.722 156 126 156H84C76.2781 156 70 149.722 70 142V58ZM98 131.5H112C113.925 131.5 115.5 133.075 115.5 135C115.5 136.925 113.925 138.5 112 138.5H98C96.075 138.5 94.5 136.925 94.5 135C94.5 133.075 96.075 131.5 98 131.5Z"
    />
  </svg>
);
